import { render, staticRenderFns } from "./boxContainer.vue?vue&type=template&id=1c02058c&"
import script from "./boxContainer.vue?vue&type=script&lang=js&"
export * from "./boxContainer.vue?vue&type=script&lang=js&"
import style0 from "./boxContainer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports